import '.bt{position:relative;}.ssr-plugin'
import '.ab{width:100%;}.ssr-plugin'
import '.g5{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.bc{align-items:flex-start;}.ssr-plugin'
import '.n{padding:2rem;}.ssr-plugin'
import '.d2{background:var(--shades-white);}.ssr-plugin'
import '.t{overflow:hidden;}.ssr-plugin'
import '.p{position:absolute;}.ssr-plugin'
import '.i5{top:50%;}.ssr-plugin'
import '.i6{right:1rem;}.ssr-plugin'
import '.i7{transform:translateY(-50%);}.ssr-plugin'
import '.i8{width:120px;}.ssr-plugin'
import '.i9{height:120px;}.ssr-plugin'
import '.ia{z-index:0;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.hn{z-index:1;}.ssr-plugin'
import '.bg{gap:0.5rem;}.ssr-plugin'
import '.ib{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="bt ab g5 a b g bc n d2 t"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="p i5 i6 i7 i8 i9 ia a c g"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="bt hn a b bc bg ib"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
